import { ssc_n_1of1_lists, ssc_n_1of1 } from './SL00000Sprint00'

import { orderedListSlide } from './SLSprint00'

import { list49200Sprint03 } from '../ActivityLists/AL49200Sprint03'
import { list49200Sprint04 } from '../ActivityLists/AL49200Sprint04'

// Constants
const sprint = 4
const activityListPrevious = () => { return list49200Sprint03(sprint-1) }
const activityList = () => { return list49200Sprint04(sprint) }

export const ssc_4_1of1_PAaA = ssc_n_1of1_lists(sprint)
export const ssc_4_1of1 = () => { 
	const substituteSprintPlanning = () => {
		return orderedListSlide('Planning', `Sprint ${sprint} Expectations:`, [
			'Similar to previous sprints with Discussion, Writing Assignment, Lab, and Reflection',
			'Different in that we will have three weeks and have Spring Break the last week of the sprint' ])
	}
	return ssc_n_1of1(sprint, ssc_4_1of1_PAaA.prework, activityListPrevious, ssc_4_1of1_PAaA.agenda, ssc_4_2of4_PAaA.prework, activityList, substituteSprintPlanning) 
}

const ssc_4_2of4_PAaA = {
	'prework': [
		'Everything is due at the end of the sprint', '',
		'Best-of-the-best Demos next Monday... don’t forget to submit your Demo assignment' ],
	'announcements':[],
	'agenda':[]
}



